
// menucomponent/AskPopupModal.js
import React from "react";

export default function AskPopupModal({
  occasion, setOccasion,
  budget, setBudget,
  sharingStyle, setSharingStyle,
  vegCount, setVegCount,
  nonVegCount, setNonVegCount,
  preferences, setPreferences,
  spiceLevel, setSpiceLevel,
  cuisine, setCuisine,
  closeAskPopup,
  handleAskConfirm
}) {
  return (
    <div className="modal fullscreen" role="dialog" aria-modal="true">
      <div className="modal-inner menu-ask-inner">
        <button className="close-btn" onClick={closeAskPopup}>×</button>
        <h3>Let's Customize Your Order!</h3>
        <div className="menu-ask-section">
          <h4>1️⃣ Occasion</h4>
          <p>Hey! Is this a casual meet, celebration, or something else?</p>
          <input
            type="text"
            value={occasion}
            onChange={(e) => setOccasion(e.target.value)}
            className="menu-ask-input"
            placeholder="e.g., Casual meet"
          />
        </div>
        <div className="menu-ask-section">
          <h4>2️⃣ Budget</h4>
          <p>Should I keep it under a certain budget for the group?</p>
          <input
            type="text"
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
            className="menu-ask-input"
            placeholder="e.g., ₹2000"
          />
        </div>
        <div className="menu-ask-section">
          <h4>3️⃣ Sharing Style</h4>
          <p>Would you like to share big dishes or have individual plates for each person?</p>
          <select
            value={sharingStyle}
            onChange={(e) => setSharingStyle(e.target.value)}
            className="menu-ask-select"
          >
            <option value="sharing">Sharing big dishes</option>
            <option value="individual">Individual plates</option>
          </select>
        </div>
        <div className="menu-ask-section">
          <h4>4️⃣ Diet Breakdown</h4>
          <p>How many of you eat veg only, and how many eat non-veg? (e.g., “2 veg, 3 non-veg”)</p>
          <div className="menu-ask-diet-counts">
            <label>Veg: </label>
            <input
              type="number"
              value={vegCount}
              onChange={(e) => setVegCount(parseInt(e.target.value) || 0)}
              className="menu-ask-number-input"
              min="0"
            />
            <label>Non-Veg: </label>
            <input
              type="number"
              value={nonVegCount}
              onChange={(e) => setNonVegCount(parseInt(e.target.value) || 0)}
              className="menu-ask-number-input"
              min="0"
            />
          </div>
        </div>
        <div className="menu-ask-section">
          <h4>5️⃣ Food Preferences & Spice</h4>
          <p>Any must-haves or dislikes? And mild, medium, or spicy?</p>
          <input
            type="text"
            value={preferences}
            onChange={(e) => setPreferences(e.target.value)}
            className="menu-ask-input"
            placeholder="e.g., No onions"
          />
          <select
            value={spiceLevel}
            onChange={(e) => setSpiceLevel(e.target.value)}
            className="menu-ask-select"
          >
            <option value="mild">Mild</option>
            <option value="medium">Medium</option>
            <option value="spicy">Spicy</option>
          </select>
        </div>
        <div className="menu-ask-section">
          <h4>6️⃣ Cuisine Choice (optional)</h4>
          <p>Are you in the mood for Indian, Chinese, or a mix?</p>
          <input
            type="text"
            value={cuisine}
            onChange={(e) => setCuisine(e.target.value)}
            className="menu-ask-input"
            placeholder="e.g., Indian"
          />
        </div>
        <div className="menu-ask-actions">
          <button className="menu-ask-cancel" onClick={closeAskPopup}>Cancel</button>
          <button className="menu-ask-confirm" onClick={handleAskConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}
